// PageLinkNode: 標準 LinkNode を継承して data-type="page-link" + data-page-id を持つ
// href は "/p/{id}" 実 URL、data-page-id で純粋な ID 取得可能

import { LinkNode } from "@lexical/link"

export class PageLinkNode extends LinkNode {
  static getType() { return "page-link" }

  static clone(node) {
    return new PageLinkNode(node.__pageId, node.__url, node.__key)
  }

  constructor(pageId, url, key) {
    super(url, { rel: null, target: null }, key)
    this.__pageId = String(pageId || "")
  }

  getPageId() { return this.getLatest().__pageId }

  createDOM(config, editor) {
    const dom = super.createDOM(config, editor)
    dom.setAttribute("data-type", "page-link")
    dom.setAttribute("data-page-id", this.__pageId)
    return dom
  }

  updateDOM(prev, dom, config) {
    super.updateDOM(prev, dom, config)
    if (prev.__pageId !== this.__pageId) {
      dom.setAttribute("data-page-id", this.__pageId)
    }
    return false
  }

  static importDOM() {
    return {
      a: (node) => {
        if (node.getAttribute("data-type") !== "page-link") return null
        return {
          conversion: (el) => ({
            node: $createPageLinkNode(
              el.getAttribute("data-page-id") || "",
              el.getAttribute("href") || ""
            )
          }),
          priority: 2,  // 標準 LinkNode より優先
        }
      },
    }
  }

  exportDOM(editor) {
    // editor を親に転送しないと LinkNode.exportDOM 内で editor._config が
    // undefined になり TypeError (page-link を含むページの編集が全滅) になる。
    const { element } = super.exportDOM(editor)
    if (element && element.setAttribute) {
      element.setAttribute("data-type", "page-link")
      element.setAttribute("data-page-id", this.__pageId)
    }
    return { element }
  }

  static importJSON(serialized) {
    return $createPageLinkNode(serialized.pageId, serialized.url)
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "page-link",
      pageId: this.__pageId,
      version: 1,
    }
  }
}

export function $createPageLinkNode(pageId, url) {
  return new PageLinkNode(pageId, url)
}

export function $isPageLinkNode(node) {
  return node instanceof PageLinkNode
}
